import Flickity from 'flickity';

function observeShowHideSlider(targetNode, flickity)
{
	let isActive = false
	
	const setupObserver = () => {
		const config = {
			attributes: true,
			childList: true,
			subtree: true,
		};
	
		// Callback function to execute when mutations are observed
		const callback = function(mutationsList, observer) {
			mutationsList.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						if(mutation.target.classList.contains('active'))
						{
							flickity.resize();
						}
					}
			});
		};
	
		const observer = new MutationObserver(callback);
	
		observer.observe(targetNode, config);
	}

	setupObserver();

	return isActive;
}

export function sliders()
{
	let sliders = document.querySelectorAll('.slider');

	sliders.forEach((slider) => {
		let flickity = null;

		let dots = slider.getAttribute('data-dots');
		let autoSlide = slider.getAttribute('data-auto');
		let nav = slider.getAttribute('data-nav');
		let autoHeight = slider.getAttribute('data-autoheight');
		let drag = slider.getAttribute('data-drag');
		let align = 'left';
		let sliderIsAnimating = false;

		dots = (dots && dots !== null) 
			? JSON.parse(dots.toLowerCase())
			: false;

		drag = (drag && drag !== null) 
			? JSON.parse(drag.toLowerCase())
			: true;

		autoHeight = (autoHeight && autoHeight !== null) 
			? JSON.parse(autoHeight.toLowerCase())
			: false;

		nav = (nav && nav !== null) 
			? JSON.parse(nav.toLowerCase())
			: false;

		let options = {
			wrapAround: true,
			selectedAttraction: 0.2,
			friction: 0.8,
			draggable: drag,
			setGallerySize: true,
			cellAlign: align,
			prevNextButtons: false,
			pageDots: dots,
			fade: true,
			accessibility: true,
			freeScroll: true,
		};

		if(slider.classList.contains('team-slider'))
		{
			options.wrapAround = false;
			options.cellAlign = 'left';
			options.contain = true;
		}

		if(autoSlide)
		{
			options.autoPlay = 4000;
			options.pauseAutoPlayOnHover = true;
		}

		let currentIndex;

		flickity = new Flickity(slider, options)

		flickity.on( 'change', (index) => {
			currentIndex = index;

			slider.classList.add('active');
			slider.parentNode.classList.add('active');

			if(currentIndex === 0)
			{
				slider.classList.remove('active');
				slider.parentNode.classList.remove('active');
			}
		});

		flickity.on('settle', () => {
			sliderIsAnimating = false;
		});
		
		flickity.on('select', () => {
			sliderIsAnimating = true;
		});

		let ancestor = slider.parentNode.parentNode.parentNode.parentNode;

		if(ancestor.classList.contains('show-hide'))
		{
			observeShowHideSlider(ancestor, flickity);
		}

		if(nav)
		{
			let parent = slider.parentNode;

			let prevButton = parent.querySelector('.slider__button.prev');
			let nextButton = parent.querySelector('.slider__button.next');

			if(prevButton)
			{
				prevButton.addEventListener('click', () => {
					flickity.previous(true);
				});
			}

			if(nextButton)
			{
				nextButton.addEventListener('click', () => {
					flickity.next(true);
				});
			}
		}
	});
}

// export function landing_slider()
// {
// 	let slider = document.querySelectorAll('.landing-typewriter__slide');

// 	let index = 0;

// 	setInterval(() => {

// 		slider.forEach((slide, i) => {
// 			if(i === index) {
// 				slide.classList.add('active');
// 			} else {
// 				slide.classList.remove('active');
// 			}
// 		})


// 		index++;

// 		if (index === slider.length){
// 			index = 0;
// 		}
// 	}, 2600 );
// }



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js